import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import 'commons-vehicle/Vehicle/components/PaymentV2/CashPayment/CashPayment.scss';

const CONTENT_ZONE_GROUP = {
    LISTING: 'widget.listing.used',
    VDP: 'widget.build.and.buy',
};

const getMSRPLabel = () => {
    const contentZoneName = 'msrp.label';
    let contentZoneMSRPLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.LISTING, contentZoneName);
    if (!contentZoneMSRPLabel || !contentZoneMSRPLabel.getText()) {
        contentZoneMSRPLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP, contentZoneName);
    }
    return (contentZoneMSRPLabel && contentZoneMSRPLabel.getText()) || LocaleService.t('VEHICLE_TILE.USED_PDSF');
};

const CashPayment = ({ children, isUsed, msrp }) => {
    return (
        <div className="cash-section tile-payment-info">
            <div className="payment-row price-row">
                <p className="payment-row-title sr-text is-bold">
                    {isUsed ? LocaleService.t('VEHICLE_TILE.USED_PDSF') : getMSRPLabel()}
                </p>
                <div className="payment-row-section">
                    {!isUsed && <p className="price-cash">{LocaleService.t('VEHICLE_TILE.CASH_BUY')}</p>}
                    <p className="payment-row-price sr-text is-bold">
                        {LocaleService.l(msrp, CurrencyFormats.CURRENCY_0)}
                    </p>
                </div>
            </div>
            {children}
        </div>
    );
};

CashPayment.defaultProps = {
    isUsed: false,
};

CashPayment.propTypes = {
    children: PropTypes.element.isRequired,
    isUsed: PropTypes.bool,
    msrp: PropTypes.number.isRequired,
};

CashPayment.displayName = 'CashPayment';

export default CashPayment;
